import { z } from "zod"

export enum IntegrationType {
    agol = "agol",
    tak = "tak",
    liveStream = "liveStream",
    autel = "autel",
    skydio = "skydio",
    dji = "dji",
    caltopo = "caltopo",
}

export const createNonSensitiveFlightRecordConnectedAccountSchema = <
    T extends z.ZodType<IntegrationType> = z.ZodType<IntegrationType>,
>(
    integrationTypeSchema?: T
) =>
    z.object({
        userId: z.string(),
        id: z.string(),
        accountId: z.string(),
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        createdAt: z.number(),
        integrationType: integrationTypeSchema ?? z.enum(IntegrationType),
    })

export const NonSensitiveFlightRecordConnectedAccountSchema =
    createNonSensitiveFlightRecordConnectedAccountSchema()

export const NonSensitiveFlightRecordConnectedAccountsSchema = z.array(
    NonSensitiveFlightRecordConnectedAccountSchema
)

export const IntegrationAuthorizationResponseSchema = z.object({
    id: z.string(),
    authorizationType: z.string(),
    integration: z.enum(IntegrationType),
    createdAt: z.number(),
    updatedAt: z.number(),
    userId: z.string(),
    workspaceId: z.string(),
    expires: z.number().optional(),
    settings: z.record(z.string(), z.unknown()),
    lastExport: z.record(z.string(), z.unknown()).optional(),
})

export type IntegrationAuthorizationResponse = z.infer<
    typeof IntegrationAuthorizationResponseSchema
>

export const IntegrationAuthorizationResponsesSchema = z.array(
    IntegrationAuthorizationResponseSchema
)

export type NonSensitiveFlightRecordConnectedAccount<T extends IntegrationType = IntegrationType> =
    Omit<z.infer<typeof NonSensitiveFlightRecordConnectedAccountSchema>, "integrationType"> & {
        integrationType: T
    }
